module.exports = __webpack_public_path__ + "img/smartphone-grey24.928286a9.svg";